export default function requiredCheckboxes (document, moduleHTML, appEventEmitter) {
  const allRelatedCheckboxes = Array.from(document.querySelectorAll(`input[name="${moduleHTML.name}"]`))
  const customValidityMessage = 'Please select at least one option.'

  allRelatedCheckboxes.forEach(checkbox => checkbox.setCustomValidity(customValidityMessage))
  moduleHTML.addEventListener('input', (event) => {
    const anyChecked = allRelatedCheckboxes.reduce((acc, relatedCheckbox) => {
      return relatedCheckbox.checked || acc
    }, false)

    allRelatedCheckboxes.forEach((element) => {
      element.required = !anyChecked
      element.setCustomValidity(!anyChecked ? customValidityMessage : '')
    })
  })
}
